import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate, translate} from "react-i18nify";
import {ReactSVG} from "react-svg";

import * as componentTypes from "../../../constants/componentTypes";
import * as navigationActions from "../../../actions/navigationActions";
import * as batchStatuses from "../../../constants/batchStatuses";
import * as modelHelper from "../../../helpers/modelHelper";

import imgClose2 from "../../../resources/img/svgicons/close2.svg";
import imgInfo2 from "../../../resources/img/svgicons/info2.svg";
import imgWarning3 from "../../../resources/img/svgicons/warning3.svg";

import Modal from "../generic/Modal";
import Button from "../generic/Button";

class BeforeDispenseColorantBatchModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            hasInvalid: this.props.params.colorants.some(
                (colorant) => colorant.status === batchStatuses.BATCH_STATUS_INVALID
            )
        };
    }

    handleCloseModalClick = () => {
        this.props.dispatchCloseModalAction();
    };

    handleConfirmClick = () => {
        this.props.dispatchAction(this.props.params.next);
        this.props.dispatchCloseModalAction();
    };

    renderColorant = (colorant) => {
        const isInvalid = colorant.status === batchStatuses.BATCH_STATUS_INVALID;
        return (
            <div key={colorant.name} className={"col-12 " + (isInvalid ? "color-error" : "color-warning")}>
                <div className="col-12 font-size-2em text-center">
                    {isInvalid
                        ? translate("beforeDispenseColorantBatch.defectiveInfoLine1")
                        : translate("beforeDispenseColorantBatch.warningInfoLine1")}
                    <strong>{" " + colorant.name + " "}</strong>
                    {isInvalid
                        ? translate("beforeDispenseColorantBatch.defectiveInfoLine2")
                        : translate("beforeDispenseColorantBatch.warningInfoLine2")}
                </div>
                <span className="col-12 flex flex-align-center font-size-1_5em">
                    <Translate value="beforeDispenseColorantBatch.batchNumber" batchNumber={colorant.batchNumber} />
                </span>
            </div>
        );
    };

    getContent = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                <ReactSVG
                    className={
                        "flex flex-align-center width-100per margin-bottom-10 react-svg-icon " +
                        (this.state.hasInvalid ? "fill-error" : "fill-warning")
                    }
                    src={this.state.hasInvalid ? imgClose2 : imgWarning3}
                    alt={this.state.hasInvalid ? "invalid" : "warning"}
                    wrapper="span"
                />
                {this.props.params.colorants.map(this.renderColorant)}
            </React.Fragment>,
            "flex flex-column"
        );
    };

    getSecondFooterPart = () => {
        if (this.state.hasInvalid) {
            return (
                <div className="col-12 color-primary flex flex-align-center-vertical">
                    <ReactSVG className="light-blue-fill width-30" src={imgInfo2} alt="info" />
                    &nbsp;
                    <span>
                        <Translate value="beforeDispenseColorantBatch.colorantIsDefective" />
                        <br />
                        <Translate value="beforeDispenseColorantBatch.emptyQuickTint" />
                    </span>
                </div>
            );
        }

        return (
            <Button
                label={<Translate value="help.formulaValidation.warningConfirmBtn" />}
                onClick={this.handleConfirmClick}
            />
        );
    };

    getFooter = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                <Button
                    className="margin-right-auto"
                    label={<Translate value="helperDialog.btnAbort" />}
                    onClick={this.handleCloseModalClick}
                />
                {this.getSecondFooterPart()}
            </React.Fragment>,
            "flex flex-gap-10px flex-wrap"
        );
    };

    render() {
        return (
            <Modal
                modalId={this.props.id}
                onClose={this.handleCloseModalClick}
                content={this.getContent()}
                footer={this.getFooter()}
            />
        );
    }
}

const mapStoreToProps = () => {
    return {};
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.BEFORE_DISPENSE_COLORANT_BATCH_MODAL));
        },
        dispatchAction: (action) => {
            dispatch(action);
        }
    };
};

export default BeforeDispenseColorantBatchModal = connect(
    mapStoreToProps,
    mapDispatchToProps
)(BeforeDispenseColorantBatchModal);
